const requireAPIS = require.context(
  // 其组件目录的相对路径
  './',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /(\d+)\.(js)$/
)

let modules = {}
let apis = {}
requireAPIS.keys().forEach(fileName => {
  let moduleId = ''
  fileName.replace(/\/(\d+).js/, (val, $1) => {
    moduleId = $1
  })
  // 获取组件配置
  const componentConfig = requireAPIS(fileName)
  modules[moduleId] = componentConfig
  apis = {
    ...apis,
    ...componentConfig
  }
})

export default function useAPIS(useState, moduleIds) {
  let params = []
  if (useState) {
    params = [useState]
  }
  let moludeFunc = {}
  let APIS = {}

  const parseModuleId = moduleIds => {
    if (moduleIds && moduleIds.length > 0) {
      moduleIds.map(id => {
        moludeFunc = {
          ...moludeFunc,
          ...modules[id]
        }
      })
    } else {
      moludeFunc = apis
    }
  }
  const deepFunc = (obj, key) => {
    const target = key ? obj[key] : obj
    if (typeof target === 'object') {
      Object.keys(target).forEach(subKey => {
        deepFunc(target, subKey)
      })
    } else if (typeof target === 'function') {
      APIS[key] = function() {
        return target.apply(this, [...params, ...arguments])
      }
      Object.assign(APIS, {
        [key]: APIS[key]
      })
    }
  }
  parseModuleId(moduleIds)
  deepFunc(moludeFunc)
  return APIS
}
